import moment from 'moment'
import { primary_color } from '../../../../Helper/uiHelper'
import TicketAssigned from './ticketAssigned'
import TicketStatus from './ticketStatus'
import { Button } from 'reactstrap'
import { useState } from 'react'
import { AvForm } from 'availity-reactstrap-validation'
import QueryType from './queryType'
import { request } from '../../../../Redux/Sagas/requests/api'
import { isSuccessResponse } from '../../../../helper'
import { useSelector } from 'react-redux'
import TicketSubject from './editSubject'
import TicketEnvironment from './ticketEnvironment'
import TicketPriority from './ticketPriority'
import TicketAzureId from './ticketAzureId'

const TicketDetails = ({ data, form, getTicketDetails, PERMISSIONS }) => {
  const [isEditMode, setIsEditMode] = useState(false)
  const [updatedData, setUpdatedData] = useState({})

  const currentUserData = useSelector((state) => state.User.user)

  const userGroupField = form?.component_call_fields?.find((item) => item?.field_id === 'assigned_to')
  const queryTypeField = form?.component_call_fields?.find((item) => item?.field_id === 'query_type')

  // CMS staff (Student/Admin/School/Manager) can always edit open tickets — including
  // ones they created via "+". Parents/Guests (5/6) viewing their own stay read-only.
  const roleId = Number(currentUserData?.role_id)
  const isStaffActor = [1, 2, 3, 4].includes(roleId)
  const isClosed = data?.ticket?.user_status?.toLowerCase() === 'closed'
  const isOwner = currentUserData?.id === data?.ticket?.user_id
  const canEditSidebar = Boolean(data?.ticket && !isClosed && (isStaffActor || !isOwner))

  const onSave = () => {
    request('raise-ticket/ticket/update', 'POST', {
      ...updatedData,
      ticket_id: data?.ticket?.id,
    }).then((res) => {
      if (isSuccessResponse(res, 'data updated successfully!')) {
        getTicketDetails()
        setIsEditMode(false)
        setUpdatedData({})
      }
    })
  }
  const user_groups = updatedData?.user_groups || data?.user_groups

  return (
    <div>
      {Object.keys(updatedData).length > 0 && (
        <Button
          color='success'
          className='mb-4 subtitle1 mr-3'
          onClick={() => {
            onSave()
          }}
          // style={{ background: `${primary_color}11`, color: primary_color, border: 'none' }}
        >
          Save
        </Button>
      )}
      {data?.ticket && (
        <>
          {!canEditSidebar ? (
            <>
              <div className='mt-5'></div>
            </>
          ) : (
            <>
              {isEditMode ? (
                <Button
                  outline
                  color='danger'
                  className='mb-4 subtitle1'
                  // style={{ background: `${primary_color}11`, color: primary_color, border: 'none' }}
                  onClick={() => {
                    setIsEditMode(false)
                    setUpdatedData({})
                  }}>
                  Cancel
                </Button>
              ) : (
                <Button
                  color='dark'
                  className='mb-4 subtitle1'
                  style={{ background: `${primary_color}11`, color: primary_color, border: 'none' }}
                  onClick={() => {
                    setIsEditMode(true)
                  }}>
                  <i class='fa-solid fa-pen-to-square mr-2'></i> Edit
                </Button>
              )}
            </>
          )}
        </>
      )}

      <AvForm className='mr-4'>
        <div className='mb-3'>
          <div className='subtitle1 font-weight-bold' style={{ color: primary_color }}>
            Ticket ID
          </div>
          <div className='subtitle1 text-muted'>#{data?.ticket?.id}</div>
        </div>

        <div className='mb-3'>
          <div className='subtitle1 font-weight-bold' style={{ color: primary_color }}>
            Booking ID
          </div>
          <div
            className='subtitle1 text-muted cursor-pointer'
            onClick={() => {
              if (!data?.ticket?.booking_id) return
              let url = '/purchase-list?' + 'selected_ids=' + data?.ticket?.booking_id + '&search_field=booking_id'
              window.open(url, '_blank')
            }}
            style={{
              color: primary_color,
              textDecoration: data?.ticket?.booking_id && 'underline',
            }}>
            {data?.ticket?.booking_id || 'N/A'}
          </div>
        </div>

        <div className='mb-3'>
          <div className='subtitle1 font-weight-bold mb-2' style={{ color: primary_color }}>
            Status
          </div>
          <TicketStatus status={data?.ticket?.user_status} isEditMode={isEditMode} setUpdatedData={setUpdatedData} />
        </div>
        <div className='mb-3'>
          <div className='subtitle1 font-weight-bold mb-2' style={{ color: primary_color }}>
            Assigned to
          </div>

          <TicketAssigned
            field={userGroupField}
            isEditMode={isEditMode}
            setUpdatedData={setUpdatedData}
            defaultValue={user_groups?.map((item) => {
              return {
                value: item?.id || item?.value,
                label: item?.name || item?.label,
              }
            })}
          />
        </div>
        {PERMISSIONS?.includes('environment') && (
          <div className='mb-3'>
            <div className='subtitle1 font-weight-bold mb-2' style={{ color: primary_color }}>
              Environment
            </div>
            <TicketEnvironment environment={data?.ticket?.environment} isEditMode={isEditMode} setUpdatedData={setUpdatedData} />
          </div>
        )}
        {PERMISSIONS?.includes('priority') && (
          <div className='mb-3'>
            <div className='subtitle1 font-weight-bold mb-2' style={{ color: primary_color }}>
              Priority
            </div>
            <TicketPriority priority={data?.ticket?.priority} isEditMode={isEditMode} setUpdatedData={setUpdatedData} />
          </div>
        )}
        {PERMISSIONS?.includes('azure id') && (
          <div className='mb-3'>
            <div className='subtitle1 font-weight-bold mb-2' style={{ color: primary_color }}>
              Azure Id
            </div>
            <TicketAzureId data={data} isEditMode={isEditMode} setUpdatedData={setUpdatedData} />
          </div>
        )}

        <div className='mb-3'>
          <div className='subtitle1 font-weight-bold mb-2' style={{ color: primary_color }}>
            Query Type
          </div>
          <QueryType field={queryTypeField} isEditMode={isEditMode} selectedQueryType={data?.ticket?.query_type} setUpdatedData={setUpdatedData} />
        </div>
        <div className='mb-3'>
          <div className='subtitle1 font-weight-bold mb-2' style={{ color: primary_color }}>
            Raise Date
          </div>
          <div className='subtitle1 text-muted'>{moment.utc(data?.ticket?.created_at).format('Do, MMM YYYY HH:mm')}</div>
        </div>
        <div className='mb-3'>
          <div className='subtitle1 font-weight-bold mb-2' style={{ color: primary_color }}>
            Who raised
          </div>
          <div className='subtitle1 text-muted'>
            {data?.who_raised?.first_name} {data?.who_raised?.surname}
          </div>
        </div>
        <div className='mb-3'>
          <div className='subtitle1 font-weight-bold mb-2' style={{ color: primary_color }}>
            Subject
          </div>
          <TicketSubject data={data} isEditMode={isEditMode} setUpdatedData={setUpdatedData} />
        </div>
      </AvForm>
    </div>
  )
}

export default TicketDetails
